import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GroupPersonality } from 'Types/GroupsTypes';
import {
  backgroundColorParsing, isFreeUser, parseColorGradientMixture, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  selectCompanyDetailFlurry, selectCompanyDetailsCall,
} from 'Selector/CompaniesSelector';
import { Executive } from 'Types/PersonTypes';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { Badge, Modal } from 'antd';
import { selectDeletingLoader, selectGroupShared } from 'Selector/GroupsSelector';
import { actions } from 'Slice/GroupsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { CLUSTER_DETAIL_ROUTE, GROUP_DETAIL_ROUTE, PEOPLE_ROUTE, translateSkipAreas } from 'Utils/Constants';
import { prefetchClusterDetailRoute } from 'Utils/routePrefetch';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import BinIconCommon from '../assets/svgIcons/BinIconCommon';
import ShareGroupPeopleModal from '../modal/ShareGroupPeopleModal';
import SharedBadge from './SharedBadge';
import {
  secondaryFont, primaryHeadingColor, wMedium,
  maxWidth, retina, primaryFont,
  maxWidth1300, primaryColor,
  smMobile,
  maxTablet,
  maxMobile,
  minWidthApp,
  nutenixGradientColor,
  minExtraLargeScreen,
  greyColorSecondary,
  textBlack,
} from '../../../Utils/utilsStyle';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';
import CrossCircle from '../assets/svgIcons/CrossCircle';
import PinItemSvg from '../assets/svgIcons/PinItemSvg';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import { Company } from '../../../Types/CompaniesTypes';

type Props = {
  clusterPersona?: GroupPersonality[]
  createdBy: Executive
  companies?: Company[]
  clusterName?: string,
  clusterId?: number,
  members?: number
  isShared?: boolean,
  sharedBy: Executive,
  disableNavigation?: boolean,
  isSearchPage?: boolean,
  inGlobalSearch?: boolean,
  pin?: number,
  commonGroup?: boolean,
} | typeof defaultProps;

const defaultProps = {
  clusterPersona: [],
  createdBy: null,
  companies: [],
  clusterName: 'Not valid group',
  clusterId: 0,
  members: 0,
  isShared: false,
  sharedBy: null,
  disableNavigation: false,
  isSearchPage: false,
  inGlobalSearch: false,
  pin: 0,
  commonGroup: false,
};

const Wrapper = styled.div<{ color: string, }>`
  background: conic-gradient(from -70deg, ${(props) => props.color});
  background-color: ${(props) => props.color};
  padding: 4px;
  border-radius: 12px;
  height: 100%;
  cursor: pointer;
  &.searchBuyerCard {
    height: auto;
    .card-inner-wrapper{
      .logo-image {
        margin: 16px 0px 14px;
        column-gap: 2px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          margin: 22px 0px 32px;
          column-gap: 4px;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin: 22px 0px 12px;
          column-gap: 2px;
        }
        @media all and (max-width: ${maxTablet}) {
          margin: 12px 0px 0px;
          column-gap: 2px;
        }
        @media all and (max-width: ${maxMobile}) {
          margin: 14px 0px 26px;
          column-gap: 3px;
        }
        .frame-logo {
          width: 36px;
          height: 22px;
          margin-right: 0px;
          @media all and (min-width: ${minExtraLargeScreen}) {
            max-height: 31px;
            max-width: 48px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            max-width: 32px;
            max-height: 22px;
          }
          @media all and (max-width:${minWidthApp}) {
            max-width: 32px;
            max-height: 22px;
          }
          @media all and (max-width: ${maxTablet}) {
            max-width: 24px;
            max-height: 17px;
          }
          @media all and (max-width: ${maxMobile}) {
            max-width: 26px;
            max-height: 17px;
          }
          @media all and (max-width: ${smMobile}) {
            max-width: 41px;
            max-height: 25px;
          }
        }
      }
      .user-images {
        margin-bottom: 22px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          margin-bottom: 20px;
        }
        @media all and (max-width:${maxWidth}) {
          margin-bottom: 0px;
        }
        @media all and (max-width:1218px) {
          margin-top: 5px;
          margin-bottom: 0px;
        }
        @media all and (max-width: ${smMobile}) {
          margin-bottom: 24px;
        }
      }
    }
  }
  .card-inner-wrapper{
    background-color:#FFFFFF;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    position: relative;
    .logo-image{
      margin: 28px 0px 20px;
      min-height: 34px;
      .frame-logo {
        background: #FFFFFF;
        border: 1.5px solid #DADADA;
        box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0371566);
        border-radius: 4px;
        height: 34px;
        width: 56px;
        margin-right: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        @media all and (max-width:${minWidthApp}) {
          height: 30px;
          width: 45px;
        }
        img{
          max-height: 100%;
          height: 100%;
          padding: 0px 10px;
          width: auto;
          max-width: 65px;
          margin:0 2px;
        }
      }
    }
    .buyer-name {
      margin: 0px;
      color:${primaryHeadingColor};
      font-family: ${secondaryFont};
      font-weight:${wMedium};
      font-size:24px;
      line-height:26px;
      text-align: center;
      padding: 0 15px;
      min-height: 52px;
      width: 100%;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 20px;
      }
      @media all and (max-width: ${maxWidth1300}){
        font-size: 16px;
        line-height: 19px;
        min-height: 38px;
      }
    }
    .createdby-div {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 4px;
      margin-top: 10px;
      margin-bottom:26px;
      position: relative;
      min-height: 45px;
      z-index:0;
      @media all and (max-width:1218px) {
        margin-top: 5px;
        margin-bottom: 40px;
      }
      .text {
        color: ${greyColorSecondary};
        font-family: ${primaryFont};
        font-size: 12px;
        font-weight: ${wMedium};
        line-height: 12px;
        letter-spacing: -0.275px;
      }
      .user-images{
        .person-without-holo {
          padding: 1px !important;
        }
      }
      .owner-name {
        color: ${textBlack};
        font-family: ${primaryFont};
        font-size: 12px;
        font-weight: ${wMedium};
        line-height: 14px;
        letter-spacing: -0.424px;
      }
    }
    
  }
  .card-action-sticker{
    &.pinnedCard {
      width: 98px;
      .delt-div {
        padding: 0px 7px 0px 0px;
      }
      .pinShow {
        margin-top: 3px;
      }
      
    }
    &.commonGroupCard {
      width: 37px;
    }
    position: absolute;
    bottom: 0px;
    right: 0px;
    height: 34px;
    width: 62px;
    background: #f1f1f1;
    opacity: 1;
    border-radius: 12px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px 0px 10px;
    > div{
      padding: 7px 0px 0px 1px;
    }
    svg{
      width: 13px;
      height: 16px;
      g{
        opacity: 1;
      }
      &.pinShow {
        width: 16px;
        height: 18px;
        path {
          stroke: ${primaryColor};
          fill: ${primaryColor};
        }
      }
    }
    .share-button-group {
      background: none;
      padding: 0px;
      .icon-mode{
        .icon-mode-text {
          display: none;
        }
        .seperator {
          display: none;
        }
        .share-icon{
          svg {
              height: 18px;
              width: 15px;
              min-width: 15px;
              margin-top: 2px;
            g {
              fill: rgb(66, 75, 80);
              }
            &:hover {
              g {
                fill: ${primaryColor};
              }
            }
          }
        }
      }
    }
    .delt-div {
      padding: 0px 7px 0px 13px;
      svg {
        min-width: 13px;
        margin-top: 6px;
      }
    }
  }
`;

const CustomBadge = styled(Badge)`
&.searchCustomBadge {
  .ant-badge-count {
    width: 27px;
    height: 27px;
    top: 17px;
    border-radius: 21px;
    @media all and (min-width: ${minExtraLargeScreen}) {
      height: 38px;
      width: 38px;
      top: 20px;
      border-radius: 21px;
    }
    @media all and (max-width: ${maxWidth}) {
      width: 23px;
      height: 23px;
      min-height: 23px;
      min-width: 23px;
      top: 13px;
    }
    @media all and (max-width: ${smMobile}) {
      width: 34px;
      height: 34px;
      min-height: 21px;
      min-width: 22px;
      top: 21px;
    }
  }
}
  .ant-badge-multiple-words {
    padding: 0px 0px;
  }
  .ant-badge-count span {
    margin-top: 0px;
  }
  .ant-badge-count{
    z-index: 4;
    font-size: 11px;
    font-family: ${primaryFont};
    background:#424B50;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer; 
    height: 28px;
    width: 28px;
    position: absolute;
    top: 15px;
    right: -5px;
    border-radius: 14px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 10px;
      height: 29px;
      width: 29px;
      min-height: 29px;
      min-width: 29px;
      top:15px;
      border-radius: 15px;
      right: -6px;
    }
  }
`;

const PopupModal = styled(Modal)`
  .ant-modal-content{
    .ant-modal-body {
      padding-top: 70px;
    }
    .ant-modal-footer{
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    }
  }
`;

const AccountClusterCard = function AccountClusterCard(props: Props) {
  const {
    clusterPersona,
    createdBy,
    clusterName,
    companies,
    clusterId,
    members,
    isShared,
    sharedBy,
    disableNavigation,
    isSearchPage,
    inGlobalSearch,
    pin,
    commonGroup
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const host = window.location.href;
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const deleteLoader = useSelector(selectDeletingLoader);
  const groupShared = useSelector(selectGroupShared);
  const disclessPersonality = useSelector(selectDisclessPersonality);

  useEffect(() => {
    if (isModalVisible && !deleteLoader) {
      setIsModalVisible(deleteLoader);
    }
  }, [deleteLoader]);
  const handleOk = () => {
    if (clusterId && !deleteLoader) {
      dispatch(clusterActions.manageAccountCluster({
        type: "delete",
        clusterId: clusterId,
      }))
    }
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const deleteGroup = (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    setIsModalVisible(true);
  };

  const redirect = (clusterID = 0) => {
    if (clusterID && !disableNavigation) {
      prefetchClusterDetailRoute(clusterID);
      navigate(`${CLUSTER_DETAIL_ROUTE}${clusterID}`);
    }
  };

  const shareGroupHandler = (check: boolean) => {
    if (check) {
      dispatch(clusterActions.setSelectedClusters([{ clusterName: clusterName || '', clusterId: clusterId || 0 }]));
    }
  };


  return (
    <>
      <PopupModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} centered cancelText="No" okText="Yes" closeIcon={<CrossCircle />} width="530px">
        <p className="text_logout_popup main-message">Are you sure you want to delete the cluster?</p>
      </PopupModal>
      <Wrapper
        color={disclessPersonality ? nutenixGradientColor
          : parseColorGradientMixture(clusterPersona || [])}
        className={classNames('buyers-card-item', {
          searchBuyerCard: inGlobalSearch,
        })}
        onClick={() => redirect(clusterId)}
        onKeyPress={() => redirect(clusterId)}
        onMouseEnter={() => clusterId && prefetchClusterDetailRoute(clusterId)}
        onFocus={() => clusterId && prefetchClusterDetailRoute(clusterId)}
        role="button"
        tabIndex={0}
      >
        <div className="d-flex justify-content-center flex-column align-items-center card-inner-wrapper">
          <div
            className="d-flex justify-content-center logo-image"
            aria-label="redirect-in-group"
          >
            {companies?.slice(0, 3).map((company) => ( // show 3 logo as per sajjad
              <div className="frame-logo">
                <img src={company.companyLogo} alt="Company" />
              </div>
            ))}
          </div>
          {!inGlobalSearch && (
            <span
              className={`buyer-name text-truncate-two-line ${translateSkipAreas}`}
              aria-label="redirect-in-group"
            >
              {clusterName}
            </span>
          )}
          <div
            className="d-flex justify-content-center createdby-div"
            aria-label="redirect-in-group"
          >
            <div className='text'>Created by:</div>
            <div className='user-images'>
              {createdBy && (
                <PeopleWidgetWithOutHolo
                  logo={createdBy?.personImage}
                  persona={createdBy?.archeType.color}
                  diameter="30px"
                  diameterSm="30px"
                  diameterXsm="30px"
                  margin="0"
                  inGlobalSearch={inGlobalSearch}
                  wrapperColor={backgroundColorParsing(createdBy.personalityTypes)}
                />
              )}
            </div>
            <div className='owner-name'>
              {createdBy?.personName}
            </div>
          </div>
          {!inGlobalSearch && (
            <div className="data-footer-main">
              {isShared ? <SharedBadge label={`Shared by ${sharedBy?.personName}`} withAbsolute /> : null}
              <div
                className={classNames('card-action-sticker', {
                  pinnedCard: pin === 1,
                  commonGroupCard: commonGroup
                })}
                onClick={(e) => e.stopPropagation()}
                onKeyPress={(e) => e.stopPropagation()}
                role="button"
                tabIndex={0}
                aria-label="button"
              >
                {!isFreeUser()
                  && (
                    <ShareGroupPeopleModal
                      onClickHandler={() => {
                        shareGroupHandler(true);
                      }}
                      onCancelHandler={() => shareGroupHandler(false)}
                      iconMode
                      inClusterMode={true}
                    />
                  )}
                {
                  !commonGroup && (
                    <div
                      onClick={deleteGroup}
                      onKeyPress={deleteGroup}
                      role="button"
                      tabIndex={0}
                      className="delt-div"
                      aria-label="button"
                    >
                      <BinIconCommon />
                    </div>
                  )
                }
              </div>
            </div>
          )}
        </div>
      </Wrapper>
    </>
  );
};
AccountClusterCard.defaultProps = defaultProps;

export default AccountClusterCard;
